import { render, staticRenderFns } from "./CreateMusic.vue?vue&type=template&id=4f6b049e&scoped=true&"
import script from "./CreateMusic.vue?vue&type=script&lang=js&"
export * from "./CreateMusic.vue?vue&type=script&lang=js&"
import style0 from "./CreateMusic.vue?vue&type=style&index=0&id=4f6b049e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b049e",
  null
  
)

export default component.exports